var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListNumbers = function SvgListNumbers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28 16a1 1 0 0 1-1 1H13a1 1 0 0 1 0-2h14a1 1 0 0 1 1 1M13 9h14a1 1 0 0 0 0-2H13a1 1 0 1 0 0 2m14 14H13a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2M5.45 8.4 6 8.112V13.5a1 1 0 0 0 2 0v-7a.99.99 0 0 0-.475-.85 1 1 0 0 0-.975-.05l-2 1a1.006 1.006 0 0 0 .9 1.8m3.575 12.888c.312-.453.478-.99.475-1.538a2.75 2.75 0 0 0-5.287-1.075 1.005 1.005 0 0 0 1.85.787A.725.725 0 0 1 6.75 19a.75.75 0 0 1 .75.75.7.7 0 0 1-.112.4L4.2 24.4A1 1 0 0 0 5 26h3.5a1 1 0 0 0 0-2H7l2-2.675z"
  })));
};
export default SvgListNumbers;